module.exports = __webpack_public_path__ + "static/media/tl.2b064c7c.svg";